import { deepMerge } from "grommet/utils";
import { theme as appTheme } from "../theme";

// The shared app theme (src/theme.js) only customises a handful of global
// tokens (brand/focus/active/text, font) for the marketing pages - it never
// themes Grommet's overlay surfaces (Select dropdowns, Layer modals), which
// fall back to Grommet's own unthemed white default. That's invisible on
// the light marketing pages but renders as a jarring white box on this
// page's dark background. Extend (not replace) the shared theme so Funder
// Allocation keeps the brand palette/font but gets dark, legible overlays.
const SURFACE = "#141935";
const SURFACE_HOVER = "#1f2550";
const SURFACE_BORDER = "rgba(255, 255, 255, 0.12)";
// The shared theme's `active`/`focus` (#BA24FF) is a vivid accent meant for
// small UI (focus rings, selected pills) - as a solid full-size button fill
// it reads as too bright/neon for a dense admin tool. A deeper, less
// saturated tone works for primary actions while keeping the same hue
// family (still recognisably "this app's purple"). These are applied via
// explicit background/hoverIndicator props (see ctaButton.js), not a
// theme.button.primary override - that override didn't reliably apply.
const CTA = "#5B3FA8";
const CTA_HOVER = "#6C4CC4";

const funderAllocationTheme = deepMerge(appTheme, {
    global: {
        drop: {
            background: SURFACE,
            border: { radius: "6px", color: SURFACE_BORDER },
        },
        colors: {
            surface: SURFACE,
            "surface-hover": SURFACE_HOVER,
            "surface-border": SURFACE_BORDER,
            "status-live": "#11b979",
            "status-retired": "#9aa0c2",
            cta: CTA,
            "cta-hover": CTA_HOVER,
        },
    },
    layer: {
        background: SURFACE,
    },
});

export { funderAllocationTheme };
